import { render, staticRenderFns } from "./EditableSection.vue?vue&type=template&id=ebccddd4&"
import script from "./EditableSection.vue?vue&type=script&lang=ts&"
export * from "./EditableSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports